import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/categories';

export default function SeoArticlesSection() {
  return (
    <section id="seo-guides" className="w-full py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-wider uppercase bg-secondary-100 text-secondary-800 rounded-full">
            SEO Guides
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            OOPBuy Spreadsheet – Alle Guides & Anleitungen
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Vertiefe dein Wissen mit unseren detaillierten SEO-optimierten Artikeln. Von Sneaker-Spreadsheets bis zu Sicherheitstipps.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article, i) => (
            <Link
              key={i}
              to={`/${article.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden bg-background-200/50">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors mt-auto">
                  Weiterlesen
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/oopbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold border-2 border-primary-200 text-primary-700 rounded-md hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Alle Guides anzeigen
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}